import { type GradientTypes } from './types.js';

type SvgGradientProps = GradientTypes;

export const SvgGradient = ({
  id,
  rotation,
  stops,
  x1,
  x2,
}: SvgGradientProps) => {
  if (!stops.length) return null;
  const gradientTransform = rotation ? `rotate(${rotation})` : undefined;

  return (
    <linearGradient
      gradientTransform={gradientTransform}
      id={id}
      x1={x1}
      x2={x2}
    >
      {stops.map(({ color, offset }) => (
        <stop
          key={`${id}-stop-${offset}`}
          offset={offset}
          stopColor={color}
        />
      ))}
    </linearGradient>
  );
};
